<template>
    <div>
        退寮申請
    </div>
</template>
      
<script>
export default {};
</script>
      
<style>
</style>
      